<form [formGroup]="technicianForm" (ngSubmit)="onSubmit()" class="tech-form">

  <div class="xr-dialog-header tech-form__header">
    <h2 class="tech-form__title" mat-dialog-title>
      @if (!data) {
        {{ 'technicians_page.dialog_new' | translate }}
      } @else if (user && user.roles && user.roles.id < Roles.OPERATOR_BO) {
        {{ 'technicians_page.dialog_edit' | translate }}
      } @else {
        {{ 'technicians_page.dialog_view' | translate }}
      }
    </h2>
    <button type="button" class="xr-btn xr-btn--soft xr-btn--icon" mat-dialog-close
            [attr.aria-label]="'technicians_page.close' | translate"
            [matTooltip]="'technicians_page.close' | translate">
      <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
  </div>

  <mat-dialog-content class="mat-typography tech-form__content">
    <div class="tech-form__grid">
      <div>
        <mat-label class="tech-form__label">{{ "personal_details.name" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <input type="text" matInput id="name" formControlName="name" [readOnly]="readonly"/>
        </mat-form-field>
        @if (technicianForm.get('name')?.hasError('required') && technicianForm.get('name')?.touched) {
          <mat-error>
            {{ "personal_details.name_required" | translate }}
          </mat-error>
        }
      </div>

      <div>
        <mat-label class="tech-form__label">{{ "personal_details.lastname" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <input type="text" matInput id="lastname" formControlName="lastname" [readOnly]="readonly" />
        </mat-form-field>
        @if (technicianForm.get('lastname')?.hasError('required') && technicianForm.get('lastname')?.touched) {
          <mat-error>
            {{ "personal_details.lastname_required" | translate }}
          </mat-error>
        }
      </div>
    </div>

    <div>
      <mat-label class="tech-form__label">{{ "personal_details.email" | translate }}</mat-label>
      <mat-form-field appearance="outline" class="w-100 hide-hint">
        <input type="email" matInput id="email" formControlName="email" [readOnly]="readonly" />
      </mat-form-field>
      @if (technicianForm.get('email')?.hasError('required') && technicianForm.get('email')?.touched) {
        <mat-error>
          {{ 'login.email_required' | translate }}
        </mat-error>
      }
      @if (technicianForm.get('email')?.hasError('email') && technicianForm.get('email')?.touched) {
        <mat-error>
          {{ 'login.invalid_email' | translate }}
        </mat-error>
      }
    </div>

    <div>
      <mat-label class="tech-form__label">{{ "technicians_page.type" | translate }}</mat-label>
      <mat-form-field appearance="outline" class="w-100 hide-hint">
        <mat-select formControlName="role" id="role" [disabled]="readonly || !user || roleOptions.length < 2">
          @for (role of roleOptions; track role) {
            <mat-option [value]="role">{{ RoleLabelKeys[role] | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    @if (isNewCompany) {
      <div class="tech-form__grid">
        <div>
          <mat-label class="tech-form__label">{{ "technicians_page.new_company_name" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-100 hide-hint">
            <input type="text" matInput id="new_company_name" formControlName="new_company_name"/>
          </mat-form-field>
          @if (technicianForm.get('new_company_name')?.hasError('required') && technicianForm.get('new_company_name')?.touched) {
            <mat-error>{{ "technicians_page.new_company_name_required" | translate }}</mat-error>
          }
        </div>
        <div>
          <mat-label class="tech-form__label">{{ "technicians_page.new_company_vat" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-100 hide-hint">
            <input type="text" matInput id="new_company_vat" formControlName="new_company_vat"/>
          </mat-form-field>
          @if (technicianForm.get('new_company_vat')?.hasError('required') && technicianForm.get('new_company_vat')?.touched) {
            <mat-error>{{ "technicians_page.new_company_vat_required" | translate }}</mat-error>
          }
          @if (technicianForm.get('new_company_vat')?.hasError('vatTaken')) {
            <mat-error>{{ "technicians_page.errors.company_vat_taken" | translate }}</mat-error>
          }
        </div>
      </div>
      <p class="tech-form__role">{{ 'technicians_page.new_company_hint' | translate }}</p>
    }

    @if (showCompanySelect) {
    <div>
      <mat-label class="tech-form__label">{{ "personal_details.company" | translate }}</mat-label>
      <mat-form-field appearance="outline" class="w-100 hide-hint">
        <mat-select formControlName="company" id="company" (openedChange)="onCompanyDropdownOpened($event)" [disabled]="readonly">
          <mat-option>
            <input matInput #companyFilterInput [placeholder]="'technicians_page.search' | translate" [(ngModel)]="companyFilter"
                   [ngModelOptions]="{ standalone: true }" (click)="$event.stopPropagation()"/>
          </mat-option>
          <mat-option *ngFor="let company of filteredCompanies()" [value]="company.id">
            {{ company.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      @if (technicianForm.get('company')?.hasError('required') && technicianForm.get('company')?.touched) {
        <mat-error>
          {{ "personal_details.company_required" | translate }}
        </mat-error>
      }
    </div>
    }

    <div class="tech-form__phone">
      <div>
        <mat-label class="tech-form__label">{{ "personal_details.prefix" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100 hide-hint" color="primary">
          <mat-select formControlName="prefix" id="prefix" (openedChange)="onPrefixDropdownOpened($event)" [disabled]="readonly">
            <mat-option>
              <input matInput #filterInput [placeholder]="'technicians_page.search' | translate" [(ngModel)]="prefixFilter" [readOnly]="readonly"
                     [ngModelOptions]="{ standalone: true }" (click)="$event.stopPropagation()"/>
            </mat-option>
            <mat-option *ngFor="let prefix of filteredPrefixes()" [value]="prefix.id">
              {{ prefix.prefix }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div>
        <mat-label class="tech-form__label">{{ "personal_details.phone" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100 hide-hint" color="primary">
          <input type="tel" matInput formControlName="phone" id="phone" (input)="onPhoneInput($event)" [readOnly]="readonly"/>
          @if (technicianForm.controls['phone'].hasError('invalidPhone')) {
            <mat-error>
              {{ "personal_details.phone_validator" | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    @if (!data) {
      <p class="tech-form__role">{{ 'technicians_page.welcome_hint' | translate }}</p>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="xr-dialog-actions tech-form__actions">
    @if (user && user.roles && user.roles.id < Roles.OPERATOR_BO) {
      @if (canDelete) {
        <button type="button" class="xr-btn xr-btn--danger" (click)="deleteTechnician()">
          <i-tabler name="trash" class="icon-18 d-flex" aria-hidden="true"></i-tabler>
          {{ 'technicians_page.delete' | translate }}
        </button>
      }
      <span class="tech-form__spacer"></span>
      <button type="button" class="xr-btn xr-btn--secondary" mat-dialog-close>
        {{ 'technicians_page.cancel' | translate }}
      </button>
      <button type="submit" class="xr-btn xr-btn--primary" [disabled]="!technicianForm.valid || saving">
        {{ 'technicians_page.save' | translate }}
      </button>
    } @else {
      <button type="button" class="xr-btn xr-btn--secondary" mat-dialog-close>
        {{ 'technicians_page.close' | translate }}
      </button>
    }
  </mat-dialog-actions>
</form>
